import React from 'react'

import { cva } from 'class-variance-authority'

import { Icons } from '@/components/atoms/Icons/Icons.tsx'
import { cn } from '@/lib/utils.ts'

const SearchBoxVariants = cva(
  'flex h-9 shrink items-start justify-end rounded-corner border-t border-gray-300 bg-gray-100 px-3 py-1',
  {
    variants: {
      variant: {
        close: 'w-[42px] transition-all duration-300 ease-in-out',
        open: 'w-[307px] transition-all duration-150 ease-in-out',
      },
      disabled: {
        false: '',
        true: '',
      },
    },
    compoundVariants: [
      {
        variant: 'close',
        disabled: false,
        class: 'cursor-pointer',
      },
    ],
    defaultVariants: {
      variant: 'close',
      disabled: false,
    },
  }
)

export interface SearchBoxProps {
  className?: string
  disabled?: boolean
  onChange: (value: string) => void
}

export const SearchBox = ({ className, disabled, onChange, ...props }: SearchBoxProps) => {
  const inputRef = React.useRef<HTMLInputElement>(null)
  const [open, setOpen] = React.useState(false)

  React.useEffect(() => {
    if (inputRef.current && open) {
      inputRef.current.focus()
    }
  }, [open, inputRef])

  return (
    <div
      className={cn(SearchBoxVariants({ variant: open ? 'open' : 'close', disabled, className }))}
      onClick={() => !disabled && setOpen(true)}
      {...props}>
      <div className="flex items-center justify-end gap-3 px-0 py-1">
        <input
          className={cn(
            'font-body h-4 w-[252px] bg-transparent text-sm text-gray-800 placeholder:text-gray-500 focus:outline-hidden',
            open ? 'block' : 'hidden'
          )}
          disabled={disabled}
          type="search"
          autoFocus={open}
          placeholder="Recherche"
          onBlur={(event: React.FocusEvent<HTMLInputElement>) => {
            setOpen(Boolean(event.target.value))
          }}
          onChange={(event: React.FocusEvent<HTMLInputElement>) => {
            onChange(event.target.value)
          }}
          ref={inputRef}
        />

        <Icons.search className="size-4 fill-black" />
      </div>
    </div>
  )
}
